$(document).ready(function () {
  const table = $('.table_compl');
  if (table.length === 0) {
    return;
  };

  table.find('[comp-table-toggler]').click(function (e) {
    const innerTable = $(this).parents('table'),
      elements = innerTable.find('.hidden');
    e.preventDefault();
    $(this).find('span').toggle();

    if (innerTable.hasClass('showing')) {
      elements.hide(100);
    } else {
      elements.show(100);
    }

    innerTable.toggleClass('showing');
  });
});


const btns = document.querySelectorAll('[data-hide-btn]');

if (btns.length) {
  btns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const valueAtr = btn.getAttribute('data-hide-btn');
      const showButton = document.querySelector(`[data-show="${valueAtr}"]`);
      btn.closest(`${valueAtr}`).style.display = 'none';
      showButton.style.display = 'block';
      showButton.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    });
  })
};

